module.exports = __webpack_public_path__ + "img/fileup.4d4a9698.jpg";